import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { StoreProvider } from "@/context/StoreContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Bundle from "@/pages/Bundle";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Site = ({ children }) => (
  <div className="flex min-h-screen flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Site><Home /></Site>} />
            <Route path="/shop" element={<Site><Shop /></Site>} />
            <Route path="/bundle" element={<Site><Bundle /></Site>} />
            <Route path="/product/:slug" element={<Site><ProductPage /></Site>} />
            <Route path="/about" element={<Site><About /></Site>} />
            <Route path="/faq" element={<Site><FAQ /></Site>} />
            <Route path="/contact" element={<Site><Contact /></Site>} />
            <Route path="/legal/:type" element={<Site><Legal /></Site>} />
            <Route path="/payment/success" element={<Site><PaymentSuccess /></Site>} />
            <Route path="/payment/cancel" element={<Site><PaymentCancel /></Site>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-center" />
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
